import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ProjectExhibit =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ProjectExhibit, _BaseData);

  function ProjectExhibit() {
    _classCallCheck(this, ProjectExhibit);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProjectExhibit).call(this, "ProjectExhibit"));
  }

  _createClass(ProjectExhibit, [{
    key: "GetProperties",
    value: function () {
      var _GetProperties = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(alphaNumSearch) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetProperties/").concat(alphaNumSearch)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetProperties(_x) {
        return _GetProperties.apply(this, arguments);
      }

      return GetProperties;
    }()
  }, {
    key: "GetPropertiesByManagementCompanyId",
    value: function () {
      var _GetPropertiesByManagementCompanyId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(alphaNumSearch, managementCompanyId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPropertiesByManagementCompanyId/").concat(alphaNumSearch, "/").concat(managementCompanyId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetPropertiesByManagementCompanyId(_x2, _x3) {
        return _GetPropertiesByManagementCompanyId.apply(this, arguments);
      }

      return GetPropertiesByManagementCompanyId;
    }()
  }, {
    key: "GetPropertyExhibits",
    value: function () {
      var _GetPropertyExhibits = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPropertyExhibits/").concat(projectId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetPropertyExhibits(_x4) {
        return _GetPropertyExhibits.apply(this, arguments);
      }

      return GetPropertyExhibits;
    }()
  }, {
    key: "GetUploads",
    value: function () {
      var _GetUploads = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(projectId, exhibitId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetUploads/").concat(projectId, "/").concat(exhibitId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetUploads(_x5, _x6) {
        return _GetUploads.apply(this, arguments);
      }

      return GetUploads;
    }()
  }, {
    key: "SendSetUpEmail",
    value: function () {
      var _SendSetUpEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(projectId, exhibitId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.post("/api/".concat(this._controller, "/SendSetUpEmail/").concat(projectId, "/").concat(exhibitId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function SendSetUpEmail(_x7, _x8) {
        return _SendSetUpEmail.apply(this, arguments);
      }

      return SendSetUpEmail;
    }()
  }, {
    key: "GetReviewRows",
    value: function () {
      var _GetReviewRows = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(statusId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/".concat(this._controller, "/GetReviewRows/").concat(statusId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function GetReviewRows(_x9) {
        return _GetReviewRows.apply(this, arguments);
      }

      return GetReviewRows;
    }()
  }, {
    key: "GetRejectionComments",
    value: function () {
      var _GetRejectionComments = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(projectExhibit) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/".concat(this._controller, "/GetRejectionComments"), projectExhibit));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function GetRejectionComments(_x10) {
        return _GetRejectionComments.apply(this, arguments);
      }

      return GetRejectionComments;
    }()
  }, {
    key: "UpdateProjectExhibit",
    value: function () {
      var _UpdateProjectExhibit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(projectExhibit) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.post("/api/".concat(this._controller, "/UpdateProjectExhibit"), projectExhibit));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function UpdateProjectExhibit(_x11) {
        return _UpdateProjectExhibit.apply(this, arguments);
      }

      return UpdateProjectExhibit;
    }()
  }, {
    key: "UploadFile",
    value: function () {
      var _UploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(files, projectId, exhibitId, periodDate) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                formData = new FormData();
                files.forEach(function (file) {
                  formData.append("files[]", file);
                });

                if (!(periodDate == null)) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt("return", axios.post("/api/".concat(this._controller, "/FileUpload/").concat(projectId, "/").concat(exhibitId), formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 4:
                return _context9.abrupt("return", axios.post("/api/".concat(this._controller, "/FileUpload/").concat(projectId, "/").concat(exhibitId, "/").concat(periodDate), formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function UploadFile(_x12, _x13, _x14, _x15) {
        return _UploadFile.apply(this, arguments);
      }

      return UploadFile;
    }()
  }]);

  return ProjectExhibit;
}(BaseData);

export default new ProjectExhibit();